export default function newCallPayload(url, method, name) {
  return {
    data: {
      request: {
        url: url || 'https://google.apimetrics.xyz/get',
        method: method || 'GET',
        headers: [
          {
            value: 'application/json',
            key: 'Accept',
          },
        ],
      },
      meta: {
        name: name || `API Call ${new Date().toLocaleString()}`,
        tags: ['apimetrics:noredirect', 'apimetrics:timeout:60', 'apimetrics:standard_headers'],
      },
    },
  };
}
